<div class="row g-4 justify-content-center mt-2">

  <!-- Inview -->
  <div class="col-lg-4 col-md-6">
    <div
      class="card card-body text-center p-4 h-100 cursor-pointer platform-widget"
      (click)="inviewClick()"
    >
      <div class="mb-3">
        <i class="bi bi-globe2 fs-1 text-primary"></i>
      </div>
      <h5 class="card-title mb-1">Inview</h5>
      <p class="text-muted mb-0 small">Connectivity Management</p>
    </div>
  </div>

  <!-- MDM -->
  <div class="col-lg-4 col-md-6">
    <div
      class="card card-body text-center p-4 h-100 cursor-pointer platform-widget"
      (click)="mdmClick()"
    >
      <div class="mb-3">
        <i class="bi bi-microsoft fs-1 text-info"></i>
      </div>
      <h5 class="card-title mb-1">MDM</h5>
      <p class="text-muted mb-0 small">Device &amp; Compliance</p>
    </div>
  </div>

  <!-- SureSIM -->
  <div class="col-lg-4 col-md-6">
    <div
      class="card card-body text-center p-4 h-100 cursor-pointer platform-widget"
      (click)="sureSimClick()"
    >
      <div class="mb-3">
        <i class="ri-sim-card-2-line fs-1 text-success"></i>
      </div>
      <h5 class="card-title mb-1">SureSIM</h5>
      <p class="text-muted mb-0 small">SIM Management</p>
    </div>
  </div>

</div>

<app-information-modal-form #informationModalForm
></app-information-modal-form>
